import LessonStatus from '../../../api/LessonStatus';
import * as types from './mutation-types';

export const index = async ({commit}) => {
    const json = await new LessonStatus().index();

    commit(types.LESSON_STATUSES, json);
};

export default {
    index,
};



// WEBPACK FOOTER //
// ./src/store/modules/lessonStatus/actions.js